import s0 from '../assets/stock/iStock-1903282248.jpg' 
import s1 from '../assets/stock/iStock-1201730019.jpg' 
import s2 from '../assets/stock/iStock-1315185798.jpg' 
import s3 from '../assets/stock/iStock-1374010907.jpg' 
import s4 from '../assets/stock/iStock-1399396331.jpg' 
import s5 from '../assets/stock/iStock-1401542006.jpg' 
import s6 from '../assets/stock/iStock-1189302612.jpg' 
import s7 from '../assets/stock/iStock-1903424167.jpg' 
import s8 from '../assets/stock/iStock-1947527002.jpg' 
import s9 from '../assets/stock/iStock-1970361616.jpg' 

const StockImages = [
{
  img: s0,
  alt: "A doctor caring for a patient in a clinical office"
},
{
  img: s1,
  alt: "A doctor working at a computer"
},
{
  img: s2,
  alt: "A doctor working on a tablet"
},
{
  img: s3,
  alt: "A group of smiling doctors"
},
{
  img: s4,
  alt: "A doctor using a computer mouse"
},
{
  img: s5,
  alt: "A doctor smiling as she works on her computer"
},
{
  img: s6,
  alt: "Two doctors converse over a tablet"
},
{
  img: s7,
  alt: "A group of doctors converse at a meeting table"
},
{
  img: s8,
  alt: "A doctor explains information displayed on a tablet to her patient"
},
{
  img: s9,
  alt: "A doctor explains information displayed on a tablet to her patient"
}]

export default function StockImage(props: {index: number}) {
  return <img src={StockImages[props.index].img} alt={StockImages[props.index].alt} style={{margin: "10px", borderRadius: "5px", width: "500px", maxWidth: "100%", maxHeight: "300px"}}/>
}